// Page copy for /awards. Project/award facts come from data/awards.ts (source evidence retained there).
export const awardsPageCopy = {
  hero: {
    eyebrow: 'Selected recognition',
    titleLines: ['Landscapes with a story.', 'Work with distinction.'],
    intro:
      'A selection of recognized D.A. Alexander residential landscapes, shown with the award recognition for each project. Let the landscape take the spotlight.',
    heritage: 'Creating landscapes since 1978.',
  },
  yearLabel: (year: number) => `${year} award recognition`,
  alts: {
    northville: 'Natural stone steps and a stepping-stone path beside a wooded Northville home.',
    canton: 'A paver entry walk, seating and layered garden beds at a brick-front home in Canton.',
    plymouth: 'Hydrangeas, hostas and mature trees in a Plymouth residential garden.',
  } as Record<string, string>,
  historic: {
    label: 'Former HBA Subcontractor of the Year',
    logo: 'https://drwzpk38qkpfb.cloudfront.net/www.daalexander.com/uploaded/images/Logos%20-%20other/HBA%20Sub%20of%20the%20Year%202015%20logo%20alt.gif200x200.gif',
    logoAlt: 'Historical HBA Subcontractor of the Year award mark',
  },
  closing: {
    title: 'Bring your own landscape ideas to life.',
    text: 'Explore more selected landscapes, or tell us about the property you would like to improve.',
    action: { label: 'Explore the project gallery', href: '/gallery' },
    secondaryAction: { label: 'Start your project', href: '/contact' },
  },
};
